import React, { BaseSyntheticEvent } from 'react'
import { IonContent, IonPage } from '@ionic/react'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import PcsInformationTablet from '../pcsInformationContentTablet/PcsInformationTablet.component'
import { savePcsInformation } from '../store/pcsInformation.actions'

const PcsInformation: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.BILLING)
  }

  const onSaveClick = () => {
    dispatch(savePcsInformation())
  }

  return (
    <IonPage id='PcsInformationPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('pcsInformation.pcsInformation')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
      />
      <IonContent color='light'>
        <PcsInformationTablet />
      </IonContent>
    </IonPage>
  )
}

export default PcsInformation
